module.exports = __webpack_public_path__ + "static/media/4z2_website_logo_sup_thkust.d7773c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4z2_website_logo_sup_thkust.jpg
// module id = 80
// module chunks = 0